/** This export is automatically generated */
export const isoNow = '2025-04-14T10:24:37.696Z';
